'use strict';

module.exports = /(?=^.{8,}$)(?=.*\d)(?=.*[!@#$%^&*()_+.]+)(?![.\n])(?=.*[A-Z])(?=.*[a-z]).*$/;
